// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';

// Added polyfill to support lower version on IE
require('polyfill');


window._ = require('lodash');

// Stylesheets.
import './sass/app.scss';

import VeeValidate from 'vee-validate';

// Default config for VeeValidate.
Vue.use(VeeValidate, {
  aria: true,
  classes: false,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  validity: false,
  inject: false
});

// Default config of axios.
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

// Load permission interceptors
require('./api/permission-interceptor');

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

// Filters & Mixins
import {rowTitleFormat, arrayValuesFormatter} from './filters/utils';
import UtilsMixin from './mixins/utils';

// Global filters
Vue.filter('rowTitleFormat', rowTitleFormat);
Vue.filter('arrayValuesFormatter', arrayValuesFormatter);

Vue.mixin(UtilsMixin);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js